import React from 'react';

import { observer } from 'mobx-react';
import { Surface } from '@infoods/lifebase-ui';

import classes from './CoachPerformanceWidget.module.scss';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { useCoachPerformanceData } from './hooks/useCoachPerformanceData';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';
import { CoachPerformanceList } from './CoachPerformanceList/CoachPerformanceList';

const CoachPerformanceWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;
  const { coachPerformanceItems } = useCoachPerformanceData({
    dateRangePreset,
    solutionTypeFilter,
  });

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Nutrition Coach Performance"
        tooltipContent={
          <>
            Revenue per nutrition coach
            <br />
            Stripe billing required
          </>
        }
      />
      <CoachPerformanceList coachPerformanceItems={coachPerformanceItems} />
    </Surface>
  );
});

export { CoachPerformanceWidget };
